<script setup lang="ts">
import { ref } from 'vue';
import FsumDialog from '@/components/Utilities/FsumDialog.vue';

defineProps<{
    title?: string;
    message?: string;
    admins: string[];
    persistent: boolean;
}>();

const dialogRef = ref<typeof FsumDialog>();
</script>

<template>
    <FsumDialog
        ref="dialogRef"
        :title="title"
        :message="message"
        :persistent="persistent"
        :card-classes="'q-pa-lg'"
    >
        <template #content>
            <ul>
                <li
                    v-for="admin, index in admins"
                    :key="index"
                >
                    {{ admin }}
                </li>
            </ul>
            <p>
                Is that correct?
            </p>
        </template>
        <template #actions>
            <q-card-actions align="evenly">
                <q-btn
                    class="fsum-button-outlined"
                    label="No, Go Back"
                    no-caps
                    @click="dialogRef?.onDialogCancel"
                />
                <q-btn
                    class="fsum-button-dark-blue"
                    label="Yes, Delete"
                    no-caps
                    @click="dialogRef?.onDialogOK"
                />
            </q-card-actions>
        </template>
    </FsumDialog>
</template>
